import { PlatformApi } from '~/services/api/platform'

export class AiSearchService extends PlatformApi {
  async createConversation() {
    return await this.post('/ai-search/conversation')
  }

  async getConversations() {
    return await this.get('/ai-search/conversation')
  }

  async getConversation(conversationId) {
    return await this.get(`/ai-search/conversation/${conversationId}`)
  }

  async deleteConversation(conversationId) {
    return await this.delete(`/ai-search/conversation/${conversationId}`)
  }

  async sendMessage(conversationId, content) {
    return await this.post(`/ai-search/conversation/${conversationId}/message`, { content })
  }
}
